import SearchBarSuggestion from 'components/common/SearchBarSuggestion';
import React from 'react';
import { SearchScopeEnum } from 'redux/search/types';
import { GeneralFunction } from 'types/common';

const ClientSearchBar: React.FC<{ onSearch: GeneralFunction }> = ({ onSearch }) => (
  <SearchBarSuggestion onSearch={onSearch} entities={[SearchScopeEnum.USER]} />
);

export default ClientSearchBar;
